import React from 'react';
import Image from 'next/image';

interface IProps {
  banner?: string;
  alt?: string;
  className?: string;
}

const Banner: React.FC<IProps> = ({ banner, alt = 'Banner', className }) => (
  <div
    className={`relative aspect-[3/1] w-full overflow-hidden 
      rounded-2xl sm:aspect-[1042/187] 
      ${className || ''}`}
  >
    {!banner && <div className="h-full w-full animate-pulse bg-gray-200" />}

    {banner && (
      <Image
        src={banner}
        alt={alt}
        fill
        priority
        className="object-cover"
        sizes="(max-width: 640px) 100vw,
               (max-width: 1024px) 90vw,
               1042px"
      />
    )}
  </div>
);

export default Banner;
